module.exports = __webpack_public_path__ + "static/media/email.78ccd097.svg";